
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.333 16.306c0-.906-.075-1.817-.235-2.709h-12.83v5.135h7.347a6.165 6.165 0 01-2.718 4.051v3.331h4.383c2.574-2.322 4.053-5.751 4.053-9.808z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M16.269 29.333c3.668 0 6.762-1.18 9.016-3.218l-4.383-3.332c-1.22.813-2.794 1.274-4.628 1.274-3.549 0-6.558-2.347-7.637-5.502H4.114v3.435c2.309 4.502 7.012 7.343 12.155 7.343z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M8.632 18.555a7.836 7.836 0 010-5.104v-3.435H4.114a13.109 13.109 0 000 11.974l4.518-3.435z","fill":"#FBBC04"}}),_c('path',{attrs:{"d":"M16.269 7.944a7.474 7.474 0 015.218 1.999l3.883-3.807a13.22 13.22 0 00-9.101-3.468c-5.143 0-9.846 2.841-12.155 7.348l4.518 3.434c1.074-3.16 4.088-5.506 7.637-5.506z","fill":"#EA4335"}})])
          )
        }
      }
    